module.exports = __webpack_public_path__ + "static/media/bipedestacion-marcha.608e8086.svg";